var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-tabs',{attrs:{"md-is-rtl":_vm.isRTL,"md-alignment":_vm.alignment,"md-sync-route":_vm.syncRoute}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }